import { render, staticRenderFns } from "./FlowExercises.vue?vue&type=template&id=047e3b24&scoped=true&"
import script from "./FlowExercises.vue?vue&type=script&lang=js&"
export * from "./FlowExercises.vue?vue&type=script&lang=js&"
import style0 from "./FlowExercises.vue?vue&type=style&index=0&id=047e3b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e3b24",
  null
  
)

export default component.exports